export const timezones = [
  { value: "America/Adak", label: "Hawaii-Aleutian (UTC-10)" },
  { value: "America/Anchorage", label: "Alaska (UTC-9)" },
  { value: "America/Chicago", label: "Central (UTC-6)" },
  { value: "America/Denver", label: "Mountain (UTC-7)" },
  { value: "America/Los_Angeles", label: "Pacific (UTC-8)" },
  { value: "America/New_York", label: "Eastern (UTC-5)" },
  { value: "Pacific/Honolulu", label: "Hawaii (UTC-10)" },
];

// USED FOR DEVELOPMENT PURPOSES
export const extendedTimezones = [
  { value: "America/Araguaina", label: "Araguaina (UTC-3)" },
  { value: "America/Bahia", label: "Bahia (UTC-3)" },
  { value: "America/Boa_Vista", label: "Boa Vista (UTC-4)" },
  { value: "America/Fortaleza", label: "Fortaleza (UTC-3)" },
  { value: "America/Maceio", label: "Maceio (UTC-3)" },
  { value: "America/Manaus", label: "Manaus (UTC-4)" },
  { value: "America/Porto_Velho", label: "Porto Velho (UTC-4)" },
  { value: "America/Recife", label: "Recife (UTC-3)" },
  { value: "America/Rio_Branco", label: "Rio Branco (UTC-4)" },
  { value: "America/Sao_Paulo", label: "Sao Paulo (UTC-3)" },
];
